<template>
  <!-- 外发管理 -->
  <div class="container">
    <!-- 按钮列表 -->
    <div
      class="glo_btnList"
      ref="btnList"
    >
      <div class="glo_btnList_left">
        <!-- 合世版 先注释 -->
        <!-- <el-button v-if="hasPermiss('admin:outgoing_bill:addOutgoingBill')" class="glo_btnItems glo_bgcMainColor" @click="addBtns">新增</el-button> -->
        <el-button
          class="glo_btnItems"
          @click="clickGZs"
        >批量过账</el-button>
        <!-- <el-button class="glo_btnItems" @click="guoZhang()">过账</el-button> -->
        <el-button
          v-if="hasPermiss('admin:outgoing_bill:cancelPosting')"
          class="glo_btnItems"
          @click="fanGuoZhang()"
        >反过账</el-button>
        <el-button
          class="glo_btnItems"
          @click="getOnoTypeList()"
        >拉取轨迹数据</el-button>
        <el-button
          class="glo_btnItems"
          @click="clickSumFreights()"
        >重算外发运费</el-button>
        <el-button
          v-if="hasPermiss('admin:outgoing_bill:delOutgoingBill')"
          class="glo_btnItems"
          @click="delBtns()"
        >删除</el-button>

        <el-dropdown
          class="topDropDown"
          @command="topCommandBtns"
        >
          <el-button type="primary">
            更多操作
            <i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="jtdc">导出</el-dropdown-item>
            <el-dropdown-item command="bgsz">表格设置</el-dropdown-item>
            <el-dropdown-item command="print_btn">打印</el-dropdown-item>
            <!-- <el-dropdown-item command="dy_a">打印承运商结算单</el-dropdown-item> -->
          </el-dropdown-menu>
        </el-dropdown>
      </div>

      <queryBtns
        :MoreConditions="MoreConditions"
        :showMoreBtns="true"
        @clerBtns="clerBtns"
        @queryBtn_ok="queryBtn_ok"
        @moreParam="moreParam"
      ></queryBtns>
    </div>
    <!-- 查询条件 -->
    <div ref="queryForm">
      <el-form
        :model="queryData"
        :class="isHaseMore ? 'glo_form hasMoreParam' : 'glo_form'"
        label-position="left"
      >
        <!-- 时间组件 -->
        <el-form-item class="queryItemsTimes">
          <multitime
            :timeType="timeType"
            :timeTypes="timeTypes"
            :startTime="startTime_a"
            :endTime="endTime_a"
            @timestatus="timestatus"
            @queryBtn_ok="queryBtn_time"
          ></multitime>
        </el-form-item>
        <el-form-item
          class="queryItems"
          label="外发单号:"
        >
          <el-input
            clearable
            placeholder="请输入"
            v-model="queryData.outgoingNumber"
          ></el-input>
        </el-form-item>
        <el-form-item
          class="queryItems"
          label="运单号:"
        >
          <el-input
            clearable
            placeholder="请输入"
            v-model="queryData.waybillNumber"
          ></el-input>
        </el-form-item>
        <el-form-item
          class="queryItems"
          label="客户名称:"
        >
          <el-select
            clearable
            filterable
            default-first-option
            v-model="queryData.customerName"
            placeholder="请选择"
            @focus="getCustomerList()"
            remote
            :remote-method="getCustomerList"
          >
            <el-option
              v-for="(item, index) in CustomerLists"
              :key="index"
              :label="item.name"
              :value="item.name"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          class="queryItems"
          label="发货员:"
        >
          <el-select
            v-model="queryData.sendEmployeeId"
            placeholder="请选择"
            clearable
            remote
            filterable
            :remote-method="
              (e) => {
                remoteMethod(e, 'employee', 'employeeList');
              }
            "
            @focus="
              (e) => {
                focusMethod('employee', 'employeeList');
              }
            "
            @clear="remoteMethod('', 'employee', 'employeeList')"
          >
            <el-option
              v-for="(item, index) in employeeList"
              :key="index"
              :label="item.name"
              :value="Number(item.documentId)"
            />
          </el-select>
        </el-form-item>
        <el-form-item
          class="queryItems"
          label="是否过账:"
        >
          <el-select
            v-model="queryData.isPosting"
            placeholder="请选择"
            clearable
            @change="queryBtn_ok"
          >
            <el-option
              v-for="item in yesOrNoList"
              :key="item.val"
              :label="item.name"
              :value="item.val"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          class="queryItems"
          label="申请报销:"
        >
          <el-select
            v-model="queryData.isExpense"
            placeholder="请选择"
            clearable
            @change="queryBtn_ok"
          >
            <el-option
              v-for="item in yesOrNoList"
              :key="item.val"
              :label="item.name"
              :value="item.val"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="业务网点:"
          class="queryItems"
        >
          <el-select
            v-model="queryData.businessDeptId"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="(item, index) in businessDeptIdArr"
              :key="index"
              :label="item.departmentName"
              :value="item.deptId"
            />
          </el-select>
        </el-form-item>
        <!-- @change="queryBtn_ok" -->
        <el-form-item
          class="queryItems"
          label="外发承运商:"
        >
          <el-select
            v-model="queryData.outboundCarrierId"
            placeholder="请选择"
            clearable
            filterable
            remote
            :remote-method="(res) => getCarrierData(res)"
            @visible-change="changeCarrier"
          >
            <el-option
              v-for="item in changeCarrierList"
              :key="item.carrierId"
              :label="item.carrierName"
              :value="item.carrierId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          class="queryItems"
          label="外发网点:"
        >
          <el-select
            v-model="queryData.startDeptId"
            placeholder="请选择"
            clearable
            @change="queryBtn_ok"
          >
            <el-option
              v-for="item in storageList"
              :key="item.documentId"
              :label="item.name"
              :value="item.documentId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          class="queryItems"
          label="结算方式:"
        >
          <el-select
            v-model="queryData.settlementMethodConfDictId"
            placeholder="请选择"
            clearable
            @focus="getConfDictValDownList('out_going_settlement_method')"
            @change="queryBtn_ok"
          >
            <el-option
              v-for="item in settlementMethodList"
              :key="item.confDictId"
              :label="item.val"
              :value="item.confDictId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          class="queryItems"
          label="到货区域:"
        >
          <el-input
            clearable
            placeholder="请输入"
            v-model="queryData.arrivalArea"
          ></el-input>
        </el-form-item>
        <el-form-item
            class="queryItems"
            label="导入批次号:"
        >
          <el-input
              clearable
              placeholder="请输入"
              v-model="queryData.importNumber"
          ></el-input>
        </el-form-item>
      </el-form>
    </div>
    <!-- 表格 -->
    <div class="glo_Table">
      <el-table
        :height="tableHeigth"
        header-align="center"
        ref="mytable"
        @row-click="rowclick"
        :data="tableData"
        border
        stripe
        :highlight-current-row="true"
        show-summary
        :summary-method="getSummaries"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          fixed="left"
          align="center"
          label="序号"
          type="index"
          width="60"
        ></el-table-column>
        <el-table-column
          fixed="left"
          align="center"
          type="selection"
          width="60"
        ></el-table-column>
        <template v-for="(item, index) in myTableHeard">
          <!-- 某个字段需要单独操作  例如点击可以跳转 -->
          <el-table-column
            v-if="item.field == 'memberNickname' && item.isShow"
            :key="index"
            :label="item.name"
            :prop="item.field"
            align="center"
            sortable
            :show-overflow-tooltip="true"
            :min-width="item.width"
            :data-isTotal="item.isTotal"
          >
            <template slot-scope="scope">
              <div
                class="linkTabel"
                @click.stop="goYdDetails(scope.row)"
              >
                {{ scope.row.memberNickname }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            :key="index"
            :label="item.name"
            :prop="item.field"
            align="center"
            sortable
            :show-overflow-tooltip="true"
            :min-width="item.width"
            :data-isTotal="item.isTotal"
            v-else-if="item && item.isShow"
          ></el-table-column>
        </template>
        <el-table-column
          fixed="right"
          label="操作"
          min-width="220px"
        >
          <template slot-scope="scope">
            <div class="tabRightBtns">
              <!-- 合世先注释 -->
              <!-- <el-button v-if="hasPermiss('admin:outgoing_bill:updateOutgoingBill')" class="rbtns" @click.stop="WaybillEdit(scope.row,1)">修改</el-button> -->
              <el-button
                class="rbtns"
                @click.stop="clickOutgoingTracking(scope.row)"
              >外发跟踪</el-button>
              <el-button
                v-if="hasPermiss('admin:outgoing_bill:updateOutgoingBill')"
                class="rbtns"
                @click.stop="WaybillEdit(scope.row, 2)"
              >修改</el-button>
              <!-- <el-button v-if="hasPermiss('admin:outgoing_bill:postingOutgoingBill')" class="rbtns" @click.stop="guoZhang(scope.row)">过账</el-button>
              <el-button v-if="hasPermiss('admin:outgoing_bill:cancelPosting')" class="rbtns" @click.stop="fanGuoZhang(scope.row)">反过账</el-button>
              <el-button v-if="hasPermiss('admin:outgoing_bill:delOutgoingBill')" class="rbtns" @click.stop="delBtns(scope.row)">删除</el-button>-->

              <!-- 如果按钮超过4个就要用下面这种下拉的样式 -->
              <el-dropdown
                class="rbtns"
                @command="handleCommandBtns($event, scope.row)"
              >
                <el-button type="primary">
                  更多操作
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-if="hasPermiss('admin:outgoing_bill:postingOutgoingBill')"
                    command="a"
                  >过账</el-dropdown-item>
                  <el-dropdown-item
                    v-if="hasPermiss('admin:outgoing_bill:cancelPosting')"
                    command="b"
                  >反过账</el-dropdown-item>
                  <el-dropdown-item
                    v-if="hasPermiss('admin:outgoing_bill:delOutgoingBill')"
                    command="c"
                  >删除</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 分页 -->
    <paging
      ref="pags"
      :pageNum="pageStart"
      :total="pageCount"
      :size="pageTotal"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
    ></paging>
    <!--        自定义表头           -->
    <sorttable
      :show_sortTableHeard="show_sortTableHeard"
      :allCheck="allCheck"
      :sortName="sortName"
      :tabelHeadeTitle="tabelHeadeTitle"
      :originalTabelHeadeTitle="originalTabelHeadeTitle"
      :selectLength="selectLength"
      @cancelSortHeard="cancelSortHeard"
      @confirmOk="confirmOk"
      @checktab="checktab"
      @checkAll="checkAll"
      @closeDias="closeDias"
    ></sorttable>

    <!-- 客户跟踪 -->
    <!-- <addCustomerTarck
      :showDia1="showDia1"
      :documentNumbers="documentNumbers"
      :documentStatus="documentStatus"
      :isdisabledStatus="true"
      @confirmAdd="confirmAdd"
      @closeDia1="closeDia1"
    ></addCustomerTarck>-->

    <!-- 拉取轨迹 -->
    <myDialog
      :diaWidth="diaWidth"
      :dialogTitle="dialogTitle"
      :isShowDialog="isShowDialog"
      @handleCloseDia="handleCloseDia"
      @diaCancelBtn="diaCancelBtn"
      @diaConfirmBtn="diaConfirmBtn"
    >
      <div class="glo_dialogForm">
        <el-form
          class="diaForm"
          ref="dialogForm"
          :model="dialogForm"
          label-width="100px"
        >
          <!-- <el-form-item class="dialogFormItems" prop="aaa" label="活动名称:">
            <el-input v-model="dialogForm.aaa"></el-input>
          </el-form-item> -->
          <el-form-item
            class="dialogFormItems"
            prop="confDictKey"
            label="第三方平台:"
          >
            <el-select
              v-model="dialogForm.confDictKey"
              placeholder="请选择"
            >
              <el-option
                v-for="(itemA, idxA) in thirdApiPlatformList"
                :key="idxA"
                :label="itemA.descript"
                :value="itemA.key"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            class="dialogFormItems"
            prop="onoType"
            label="类型:"
          >
            <el-select
              v-model="dialogForm.onoType"
              placeholder="请选择"
            >
              <el-option
                v-for="(itemA, idxA) in OnoTypeList"
                :key="idxA"
                :label="itemA.typeShow"
                :value="itemA.type"
              ></el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item class="dislogFormTextarea" prop="ccc" label="备注:">
            <el-input
              type="textarea"
              rows="2"
              v-model="dialogForm.ccc"
            ></el-input>
          </el-form-item>
          <el-form-item label="图片:">
            <uploadimgs
              @input="changeFileList"
              :fileNameLists="fileNameLists"
              :limit="6"
            ></uploadimgs>
          </el-form-item> -->
        </el-form>
        <div v-if="tableDataA.length > 0">
          <el-table
            header-align="center"
            :data="tableDataA"
            border
            stripe
          >
            <el-table-column
              fixed="left"
              align="center"
              label="序号"
              type="index"
              width="60"
            ></el-table-column>
            <el-table-column
              label="外发单号"
              prop="number"
              align="center"
              sortable
              :show-overflow-tooltip="true"
              width="220px"
            ></el-table-column>
            <el-table-column
              label="拉取结果"
              prop="msg"
              align="center"
              sortable
              :show-overflow-tooltip="true"
            ></el-table-column>
          </el-table>
        </div>
      </div>
    </myDialog>

    <!-- <prints
      :diaWidth_print="diaWidth_print"
      :dialogTitle_print="dialogTitle_print"
      :isShowDialog_print="isShowDialog_print"
      :dataList="dataList"
      :topData="topData"
      @handleCloseDia_print="handleCloseDia_print"
      @diaConfirmBtn_print="diaConfirmBtn_print"
    ></prints>-->
    <!-- 导出插件 -->
    <exportCompoent
      :isShowDialog_dc="isShowDialog_dc"
      :diaWidth_dc="diaWidth_dc"
      :dialogTitle_dc="dialogTitle_dc"
      :dialogForm_dc="dialogForm_dc"
      :tableHeard="EPtableHeard"
      :AllCheck="EPAllCheck"
      @checktabEP="checktabEP"
      @checkAllEP="checkAllEP"
      @onAfterEnter="onAfterEnter"
      @handleCloseDia_dc="handleCloseDia_dc"
      @diaConfirmBtn_dc="diaConfirmBtn_dc()"
    >
      <!-- 当前页面的查询条件 -->
      <div ref="queryForm">
        <el-form
          :model="queryData"
          class="glo_form hasMoreParam"
          label-position="left"
        >
          <el-form-item class="queryItemsTimes">
            <multitime
              :timeType="timeType"
              :timeTypes="timeTypes"
              :startTime="startTime_a"
              :endTime="endTime_a"
              @timestatus="timestatus"
              @queryBtn_ok="queryBtn_time"
            ></multitime>
          </el-form-item>
          <el-form-item
            class="queryItems"
            label="外发单号:"
          >
            <el-input
              clearable
              placeholder="请输入"
              v-model="queryData.outgoingNumber"
            ></el-input>
          </el-form-item>
          <el-form-item
            class="queryItems"
            label="运单号:"
          >
            <el-input
              clearable
              placeholder="请输入"
              v-model="queryData.waybillNumber"
            ></el-input>
          </el-form-item>
          <el-form-item
            class="queryItems"
            label="发货员:"
          >
            <el-select
              v-model="queryData.sendEmployeeId"
              placeholder="请选择"
              clearable
              remote
              filterable
              :remote-method="
                (e) => {
                  remoteMethod(e, 'employee', 'employeeList');
                }
              "
              @focus="
                (e) => {
                  focusMethod('employee', 'employeeList');
                }
              "
              @clear="remoteMethod('', 'employee', 'employeeList')"
            >
              <el-option
                v-for="(item, index) in employeeList"
                :key="index"
                :label="item.name"
                :value="Number(item.documentId)"
              />
            </el-select>
          </el-form-item>
          <el-form-item
            class="queryItems"
            label="是否过账:"
          >
            <el-select
              v-model="queryData.isPosting"
              placeholder="请选择"
              clearable
              @change="queryBtn_ok"
            >
              <el-option
                v-for="item in yesOrNoList"
                :key="item.val"
                :label="item.name"
                :value="item.val"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            class="queryItems"
            label="申请报销:"
          >
            <el-select
              v-model="queryData.isExpense"
              placeholder="请选择"
              clearable
              @change="queryBtn_ok"
            >
              <el-option
                v-for="item in yesOrNoList"
                :key="item.val"
                :label="item.name"
                :value="item.val"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="业务网点:"
            class="queryItems"
          >
            <el-select
              v-model="queryData.businessDeptId"
              placeholder="请选择"
              clearable
            >
              <el-option
                v-for="(item, index) in businessDeptIdArr"
                :key="index"
                :label="item.departmentName"
                :value="item.deptId"
              />
            </el-select>
          </el-form-item>
          <el-form-item
            class="queryItems"
            label="外发承运商:"
          >
            <el-select
              v-model="queryData.outboundCarrierId"
              placeholder="请选择"
              clearable
              filterable
              @change="queryBtn_ok"
            >
              <el-option
                v-for="item in changeCarrierList"
                :key="item.carrierId"
                :label="item.carrierName"
                :value="item.carrierId"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            class="queryItems"
            label="外发网点:"
          >
            <el-select
              v-model="queryData.startDeptId"
              placeholder="请选择"
              clearable
              @change="queryBtn_ok"
            >
              <el-option
                v-for="item in storageList"
                :key="item.documentId"
                :label="item.name"
                :value="item.documentId"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            class="queryItems"
            label="结算方式:"
          >
            <el-select
              v-model="queryData.settlementMethodConfDictId"
              placeholder="请选择"
              clearable
              @focus="getConfDictValDownList('out_going_settlement_method')"
              @change="queryBtn_ok"
            >
              <el-option
                v-for="item in settlementMethodList"
                :key="item.confDictId"
                :label="item.val"
                :value="item.confDictId"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            class="queryItems"
            label="到货区域:"
          >
            <el-input
              clearable
              placeholder="请输入"
              v-model="queryData.arrivalArea"
            ></el-input>
          </el-form-item>
          <el-form-item
            class="queryItems"
            label="导入批次号:"
          >
            <el-input
              clearable
              placeholder="请输入"
              v-model="queryData.importNumber"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
    </exportCompoent>
    <!-- 选择打印模板 -->
    <printDialog
      :dialogFrom="dialogFrom"
      ref="dialogSelect"
      title="选择模板"
      icon="el-icon-printer"
      modelTypeVal="外发单打印模板"
      @handleCreated="handleCreated"
      @handleView="handleView"
      @handleEdit="handleEdit"
      @handleOk="handleOk"
    ></printDialog>

    <!-- 创建和使用模板 -->
    <printSys
      :printForm="printForm"
      :title="printTitle"
      icon="el-icon-printer"
      @handleClose="handlePrintSysClose"
    >
      <printSysContent
        :printType="printType"
        :modelObj="modelObj"
        :modelClassName="modelClassName"
        :selectTableData="selectTableData"
      ></printSysContent>
    </printSys>

    <!-- 打印系统数据接口的className -->
    <classNameDialog
      :diaWidth="classNameDiaWidth"
      :dialogTitle="classNameDialogTitle"
      :isShowDialog="isShowClassNameDialog"
      @handleCloseDia="handleCloseClassNameDia"
      @diaCancelBtn="classNameDiaCancelBtn"
      @diaConfirmBtn="classNameDiaConfirmBtn"
    >
      <el-select
        v-model="modelClassName"
        placeholder
        style="width: 100%"
      >
        <el-option
          v-for="(value, key) in classNameArr"
          :key="key"
          :label="value.name"
          :value="value.val"
        ></el-option>
      </el-select>
    </classNameDialog>
  </div>
</template>
<script>
import sorttable from '@/components/sortTemplate.vue' //自定义排序表头
import paging from '@/components/pagings.vue' //分页组件
import multitime from '@/components/multiTime.vue'
import myDialog from '@/components/Dialog.vue'
import classNameDialog from '@/components/Dialog.vue'
import queryBtns from '@/components/queryBtns.vue'
// import addCustomerTarck from "@/components/CustomerServiceTrackingNew.vue";
import uploadimgs from '@/components/upLoadImgs.vue'
import prints from '@/components/prints/print_waiFa.vue'
import printDialog from '@/components/printDialog/index.vue'
import printSys from '@/components/printSys/index.vue'
import printSysContent from '@/components/printSys/content.vue'
import { hiprint } from '@/print.js'
import exportjs from '@/assets/js/Mixins/export.js' //导出的公共js
import jsPDF from 'jspdf'

export default {
  inject: ['reload'],
  mixins: [exportjs],
  components: {
    sorttable,
    paging,
    multitime,
    myDialog,
    uploadimgs,
    queryBtns,
    prints,
    printDialog,
    printSys,
    printSysContent,
    classNameDialog,
  },
  data() {
    return {
      //=======================导出相关 开始 =======================
      dialogForm_dc: {
        pageStart: 1,
        pageTotal: '',
        fileName: '外发列表',
        apiName: '/admin/v3/tms/waybill/outgoing/getOutgoingBillList', //导出的数据列表接口名
        EpType: 'bdd', //dd==等待下载完成,bdd==不等待完成
        apiType: 'GET', //导出当前列表的请求方式
        pageType: 'OutgoingManage', //页面类型(主要用来区分查询参参数的时间)
      },
      //=======================导出相关 结束 =======================
      // 打印预览
      isShowDialog_print: false,
      diaWidth_print: '90%',
      dialogTitle_print: '打印预览',
      dataList: [],
      tableDataA: [],
      topData: {},

      changeCarrierList: [],
      storageList: [],
      //  -----  查询  ------
      queryData: {
        endCreateTime: '',
        endOutgoingTime: '',
        outboundCarrierId: '',
        outgoingNumber: '',
        startCreateTime: '',
        startDeptId: '',
        startOutgoingTime: '',
        waybillNumber: '',
        isPosting: 0,
        isExpense: '',
        settlementMethodConfDictId: '',
        sendEmployeeId: '',
        businessDeptId: '',
        arrivalArea: '',
        importNumber: '',
      }, //  表单查询数据
      //  时间类型
      timeTypes: [
        {
          value: '0',
          label: '外发创建日期',
        },
        // {
        //   value: '1',
        //   label: '外发日期',
        // },
        {
          value: '2',
          label: '运单提货日期',
        },
      ],
      timeType: '2', //  时间类型
      startTime_a: '',
      endTime_a: '',

      MoreConditions: '更多条件', //  输入框绑定动态class
      isHaseMore: false, //false == 更多条件  true ==收起条件

      //      -------  表格  ----------
      pageStart: 1, //  页码
      pageCount: 0, //  总条数
      pageTotal: this.$COMMON.pageTotals, //  一页几条
      tableHeigth: '75vh', //  表格高度
      selectTableData: [], //  表格选中的数据

      show_sortTableHeard: false, //显示表格设置弹窗
      // 默认表头
      tabelHeadeTitle: [
        {
          name: '编号',
          field: 'number',
          width: '160',
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '外发单号',
          field: 'outgoingNumber',
          width: '110',
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '运单号',
          field: 'waybillNumber',
          width: '150',
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },

        {
          name: '导入批次号',
          field: 'importNumber',
          width: '150',
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '运单提货时间',
          field: 'takeTime',
          width: '150',
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '外发送货方式',
          field: 'sendMethod',
          width: '150',
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },

        {
          name: '任务编号',
          field: 'taskNumber',
          width: '160',
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '业务网点',
          field: 'businessDeptName',
          width: '120',
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: '客户名称',
          field: 'customerName',
          width: '110',
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '客户编号',
          field: 'customerNumber',
          width: '110',
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '客户单号',
          field: 'customerOrderNumber',
          width: '150',
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '发货员',
          field: 'sendEmployeeName',
          width: '120',
          sort: 19,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: '申请报销状态',
          field: 'applyReimburseStatus',
          width: '160',
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '到货区域',
          field: 'arrivalArea',
          width: '110',
          sort: 19,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: '是否过账',
          field: 'isPostingShow',
          width: '110',
          sort: 19,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: '是否入仓',
          field: 'isIntoStorageShow',
          width: '110',
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '入仓仓库',
          field: 'intoStorageName',
          width: '110',
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '外发网点',
          field: 'startDeptName',
          width: '110',
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '外发日期',
          field: 'outgoingTime',
          width: '160',
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '承运公司',
          field: 'outboundCarrierName',
          width: '110',
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '承运商称重',
          field: 'allCarrierWeigh',
          width: '110',
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '承运商单价',
          field: 'carrierUnitPrice',
          width: '110',
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '摊分承运商称重',
          field: 'shareCarrierWeigh',
          width: '110',
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },

        {
          name: '承运商体积',
          field: 'allCarrierVolume',
          width: '110',
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '摊分承运商体积',
          field: 'shareCarrierVolume',
          width: '110',
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },

        {
          name: '承运商件数',
          field: 'allCarrierCount',
          width: '110',
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '摊分承运商件数',
          field: 'shareCarrierCount',
          width: '110',
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '线路',
          field: 'carrierLineName',
          width: '110',
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '本地联系人',
          field: 'contacts',
          width: '110',
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '本地电话',
          field: 'localPhone',
          width: '110',
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '目的地联系人',
          field: 'destContacts',
          width: '110',
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '目的地电话',
          field: 'destPhone',
          width: '140',
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '目的地地址',
          field: 'destAddress',
          width: '180',
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '中转地址',
          field: 'transferAddress',
          width: '180',
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '中转电话',
          field: 'transferPhone',
          width: '140',
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '计费方式',
          field: 'billingMethod',
          width: '110',
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '外发重量(kg)',
          field: 'weight',
          width: '110',
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '外发体积(m³)',
          field: 'volume',
          width: '110',
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '外发件数',
          field: 'packageCount',
          width: '110',
          sort: 1,
          isShow: true, //是否展示
          isTotal: true, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '计费取值',
          field: 'billingWeight',
          width: '110',
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '单价',
          field: 'unitPrice',
          width: '110',
          sort: 1,
          isShow: true, //是否展示
          isTotal: true, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '基本运费',
          field: 'basicFreight',
          width: '110',
          sort: 1,
          isShow: true, //是否展示
          isTotal: true, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '提货费',
          field: 'takeFee',
          width: '110',
          sort: 1,
          isShow: true, //是否展示
          isTotal: true, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '送货费',
          field: 'sendFee',
          width: '110',
          sort: 1,
          isShow: true, //是否展示
          isTotal: true, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '装卸费',
          field: 'unLoadFee',
          width: '110',
          sort: 1,
          isShow: true, //是否展示
          isTotal: true, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '其他费用',
          field: 'allOtherFee',
          width: '110',
          sort: 1,
          isShow: true, //是否展示
          isTotal: true, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '外发总额',
          field: 'totalFreight',
          width: '110',
          sort: 1,
          isShow: true, //是否展示
          isTotal: true, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '是否含税',
          field: 'isInvoiceShow',
          width: '110',
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '税点',
          field: 'invoiceTaxPoint',
          width: '110',
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '税金',
          field: 'taxes',
          width: '110',
          sort: 1,
          isShow: true, //是否展示
          isTotal: true, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '应付总额',
          field: 'shouldAmount',
          width: '110',
          sort: 1,
          isShow: true, //是否展示
          isTotal: true, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '返点',
          field: 'returnAmount',
          width: '110',
          sort: 1,
          isShow: true, //是否展示
          isTotal: true, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '结算金额',
          field: 'settlementAmount',
          width: '110',
          sort: 1,
          isShow: true, //是否展示
          isTotal: true, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '摊分成本',
          field: 'apportionedCost',
          width: '110',
          sort: 1,
          isShow: true, //是否展示
          isTotal: true, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '开单运费',
          field: 'billingAmount',
          width: '110',
          sort: 1,
          isShow: true, //是否展示
          isTotal: true, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '代收货款',
          field: 'agentAmount',
          width: '110',
          sort: 1,
          isShow: true, //是否展示
          isTotal: true, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '到付金额',
          field: 'receivedAmount',
          width: '110',
          sort: 1,
          isShow: true, //是否展示
          isTotal: true, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '外发结算方式',
          field: 'settlementMethod',
          width: '110',
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '外发备注',
          field: 'remarks',
          width: '160',
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '创建时间',
          field: 'createTime',
          width: '160',
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '创建人',
          field: 'createUserName',
          width: '110',
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
      ],
      myTableHeard: [], //  我的表头
      originalTabelHeadeTitle: [], //自定义排序表头(恢复默认用)
      tableData: [], //  表格数据

      allCheck: false, //  全选
      sortName: '外发管理模板', //  排序名
      selectLength: 0, //  显示的长度

      totalArr: [], //  表格需要合计的字段
      className: '', //  导出需要
      pageGroupName: 'OutgoingManage', //  页面标识

      // 新建客服跟踪
      showDia1: false,
      documentNumbers: '',
      documentStatus: '', //包裹单据

      fileNameLists: [], //上传组件的
      // ==== 弹窗组件属性 start ====
      isShowDialog: false,
      dialogTitle: '拉取轨迹数据',
      diaWidth: '60%',
      classNameDiaWidth: '300px',
      classNameDialogTitle: '请选择className',
      isShowClassNameDialog: false,
      dialogForm: {
        // 弹窗表单数据
        onoType: '',
        numbers: [],
        confDictKey: '',
      },
      rulesForm: {
        aaa: [
          { required: true, message: '请输入', trigger: ['blur', 'change'] },
        ],
      },
      // ==== 弹窗组件属性 end ====

      rules: {
        aaa: [{ required: true, message: '请输入活动名称', trigger: 'blur' }],
      },

      // 打印模块
      // 打印弹出框
      dialogFrom: {
        dialogVisible: false,
      },
      // 创建新的打印
      printForm: {
        dialogVisible: false,
      },
      printTitle: '创建模板',
      printType: 1, // 1是创建 2是使用
      // 打印
      printDesignForm: {
        dialogVisible: false,
      },
      // 选择的模板数据
      modelObj: null,
      // 模板className
      classNameArr: [
        {
          name: '承运商结算单',
          val: 'com.bami.service.tms.v3.admin.print.vo.AdminOutgoingPrintDataV3tmsVo',
        },
        {
          name: '批量打印标签',
          val: 'com.bami.service.tms.v3.admin.print.vo.AdminOutgoingPrintBillDataV3tmsVo',
        },
      ],
      // 默认打印模板类型
      modelClassName:
        'com.bami.service.tms.v3.admin.print.vo.AdminOutgoingPrintDataV3tmsVo',
      // 下面是所有的模板类型
      modelClassName1:
        'com.bami.service.tms.v3.admin.print.vo.AdminOutgoingPrintDataV3tmsVo',
      modelClassName2:
        'com.bami.service.tms.v3.admin.print.vo.AdminOutgoingPrintBillDataV3tmsVo',

      yesOrNoList: [
        {
          name: '否',
          val: 0,
        },
        {
          name: '是',
          val: 1,
        },
      ],
      settlementMethodList: [],
      employeeList: [],
      businessDeptIdArr: [],
      CustomerLists: [],
      OnoTypeList: [],
      thirdApiPlatformList: [],
    }
  },
  updated() {
    if (this.show_sortTableHeard) {
      // 排序表头
      let arr = this.tabelHeadeTitle
      for (var i = 0; i < arr.length; i++) {
        arr[i].sort = i + 1
      }
      this.tabelHeadeTitle = arr
    }
  },
  created() {
    this.myTableHeard = this.tabelHeadeTitle
    if (this.originalTabelHeadeTitle.length === 0) {
      this.originalTabelHeadeTitle = JSON.parse(
        JSON.stringify(this.tabelHeadeTitle)
      )
    }
    this.startTime_a = this.$TOOLS.getFlexDate(this.$COMMON.timeNum) //开始时间;
    this.endTime_a = this.$TOOLS.getCurrentDate() //今天的时间;

    this.getData()
    //获取默认表头 页面有这四个字段 myTableHeard,sortName,tabelHeadeTitle,totalArr
    this.$TOOLS.getGroupFindFieldSort(this, this.pageGroupName)
    console.log(123123)
  },
  activated() {
    // 每次进页面都会触发的写这里
    //计算获取表格高度
    // this.getData();
  },
  deactivated() {},
  mounted() {
    this.getObjectUserDownList('storage')
    // this.changeCarrier();
    this.GetDept()
  },
  watch: {},
  methods: {
    // 获取蓝桥单号类型下拉列表
    getOnoTypeList() {
      //
      if (this.selectTableData.length < 1) {
        this.$message.error('请选择表格数据')
        return false
      }
      this.dialogForm.numbers = this.selectTableData.map((item) => {
        return item.outgoingNumber
      })
      // 获取类型
      this.$API.getOnoTypeList().then((res) => {
        this.OnoTypeList = res.data.result || []
        if (this.OnoTypeList.length > 0) {
          this.dialogForm.onoType = this.OnoTypeList[0].type
        }
      })

      this.$API
        .runPageReportDetails({
          number: 'select_dict_by_type',
          conditionReqs: [
            {
              conditonKey: 'type',
              conditonVal: 'third_api_platform',
            },
          ],
        })
        .then((res) => {
          this.thirdApiPlatformList = res.data.result.datas || []
          if (this.thirdApiPlatformList.length > 0) {
            this.dialogForm.confDictKey = this.thirdApiPlatformList[0].key
          }
        })

      this.isShowDialog = true
    },

    // 获取客户列表
    getCustomerList(name) {
      this.$API
        .wtl_getObjectUserDownList({
          key: 'customer',
          name: name || '',
          pageStart: 1,
          pageTotal: 200,
        })
        .then((res) => {
          this.CustomerLists = res.data.result.data || []
        })
    },
    // 获取业务网点（组织架构列表）
    GetDept() {
      this.$API.wtl_getDeptList().then((res) => {
        if (res.data.status === 'success') {
          let result = res.data.result?.data || []
          this.businessDeptIdArr = result
        }
      })
    },
    //员工、部门、外发网点
    focusMethod(key, keys) {
      if (this[keys].length == 0) {
        this.remoteMethod('', key, keys)
      }
    },
    // //员工、部门、外发网点
    // changeMethod(e, arrs, keys) {
    //   let curs = this[arrs].filter((item) => item.documentId == e);
    //   if (keys == "intoDeptName") {
    //     this.rukuPlanReq[keys] = (curs.length && curs[0].name) || "";
    //   } else {
    //     this.commandReq[keys] = (curs.length && curs[0].name) || "";
    //   }
    // },
    // 员工、部门、外发网点
    remoteMethod(name, key, keys) {
      // employee 员工
      // dept 部门
      // storage 外发网点
      return this.$API
        .wtl_getObjectUserDownList({
          name,
          key,
          pageStart: 1,
          pageTotal: 20,
        })
        .then((res) => {
          let arrs = res.data.result.data || []
          this[keys] = arrs
        })
    },

    // 根据字典类型获取字典值下拉列表
    getConfDictValDownList(type) {
      this.$COMAPI.getConfDictValDownList(type).then((res) => {
        // 外发结算方式
        if (type == 'out_going_settlement_method') {
          this.settlementMethodList = res || []
        }
      }) //送货方式
    },
    clickOutgoingTracking({
      outboundCarrierId,
      outboundCarrierName,
      number,
      outgoingId,
    }) {
      console.log(outgoingId)
      let query = {
        number,
        outboundCarrierId,
        outboundCarrierName,
        outgoingId,
      }
      this.$router.push({
        path: '/OutgoingManage/OutgoingTracking',
        query,
      })
    },
    clickGZs() {
      let ids = []
      if (this.selectTableData.length < 1) {
        this.$message.error('请至少选择一条数据进行操作')
        return false
      }
      this.selectTableData.forEach((item) => {
        ids.push(item.outgoingId)
      })
      this.$confirm('确定要批量过账吗? 请谨慎操作', '提示:')
        .then((res) => {
          this.$API.outgoingbatchPosting({ outgoingIds: ids }).then((res) => {
            this.$message.success(res.data.message || '操作成功')
            this.getData()
          })
        })
        .catch((err) => {})
    },

    clickSumFreights() {
      let ids = []
      if (this.selectTableData.length < 1) {
        this.$message.error('请至少选择一条数据进行操作')
        return false
      }
      this.selectTableData.forEach((item) => {
        ids.push(item.outgoingId)
      })
      this.$confirm('确定要批量重算吗? 请谨慎操作', '提示:')
          .then((res) => {
            this.$API.batchFormulaFreight({ outgoingIds: ids }).then((res) => {
              this.$message.success(res.data.message || '操作成功')
              this.getData()
            })
          })
          .catch((err) => {})
    },

    handleCloseClassNameDia() {
      this.isShowClassNameDialog = false
    },
    classNameDiaCancelBtn() {
      this.isShowClassNameDialog = false
    },
    classNameDiaConfirmBtn() {
      // modelClassName
      if (!this.modelClassName) {
        this.$message.error('请选择className')
        return
      }
      this.isShowClassNameDialog = false
      setTimeout(() => {
        this.dialogFrom.dialogVisible = false
        this.printTitle = '创建模板'
        this.printType = 1
        this.modelObj = null
        setTimeout(() => {
          this.printForm.dialogVisible = true
        }, 300)
      }, 300)
    },
    // 打印系统关闭
    handlePrintSysClose() {
      if (this.$refs.dialogSelect) {
        this.$refs.dialogSelect.doSearch()
      }
    },
    // 打印弹出框创建
    handleCreated() {
      this.isShowClassNameDialog = true
    },
    // 打印预览模板
    handleEdit(obj) {
      // this.dialogFrom.dialogVisible = false;
      this.printTitle = obj.modelName
      this.printType = 2
      this.modelObj = obj
      setTimeout(() => {
        this.printForm.dialogVisible = true
      }, 300)
    },
    // 打印预览模板
    handleView(obj) {
      console.log('obj', obj)
      let hiprintTemplate = new hiprint.PrintTemplate({
        template: JSON.parse(obj.content),
      })
      let idarr = []
      for (let i = 0; i < this.selectTableData.length; i++) {
        idarr.push(this.selectTableData[i].outgoingId)
      }
      if (obj.className == this.modelClassName2) {
        this.$API
          .getOutgoingTabPrintData({
            outgoingIds: idarr,
          })
          .then((res) => {
            if (res.status == 200) {
              if (res.data && res.data.status == 'success') {
                const result = res.data.result
                hiprintTemplate.print(result, {})
              }
            }
          })
      } else if (obj.className == this.modelClassName1) {
        this.$API
          .getOutgoingPrintData({
            outgoingIds: idarr,
          })
          .then((res) => {
            if (res.status == 200) {
              if (res.data && res.data.status == 'success') {
                const result = res.data.result
                hiprintTemplate.print(result, {})
              }
            }
          })
      }
    },
    // 确定模板的数据
    handleOk(obj) {
      let hiprintTemplate = new hiprint.PrintTemplate({
        template: JSON.parse(obj.content),
      })
      let idarr = []
      for (let i = 0; i < this.selectTableData.length; i++) {
        idarr.push(this.selectTableData[i].outgoingId)
      }
      if (obj.className == this.modelClassName2) {
        this.$API
          .getOutgoingTabPrintData({
            outgoingIds: idarr,
          })
          .then((res) => {
            if (res.status == 200) {
              if (res.data && res.data.status == 'success') {
                const result = res.data.result
                hiprintTemplate.print(result, {})
              }
            }
          })
      } else {
        this.$API
          .getOutgoingPrintData({
            outgoingIds: idarr,
          })
          .then((res) => {
            if (res.status == 200) {
              if (res.data && res.data.status == 'success') {
                const result = res.data.result
                hiprintTemplate.print(result, {})
              }
            }
          })
      }
    },

    // 打印
    printEvent(row) {
      if (this.selectTableData.length < 1) {
        this.$message.error('请选择需要打印的外发单')
        return false
      }
      let idarr = this.selectTableData.map((item) => {
        return item.outgoingId
      })
      window.sessionStorage.setItem(
        'set_PrintSelectTableData',
        JSON.stringify(idarr)
      )
      this.dialogFrom.dialogVisible = true
    },

    // 打印相关的
    handleCloseDia_print() {
      this.isShowDialog_print = false
    },
    // 打印预览确定
    diaConfirmBtn_print() {
      this.isShowDialog_print = false
    },
    // 打印相关的

    getObjectUserDownList(key) {
      this.$COMAPI.getObjectUserDownList(key).then((res) => {
        if (key == 'storage') {
          this.storageList = res || []
        }
      }) //获取网点列表
    },

    getCarrierData(val) {
      console.log('ddddd', val)
      this.changeCarrier(true, val)
    },
    // 承运商列表
    changeCarrier(e, val) {
      console.log('AAAAAAAA', e, val)
      if (!e) {
        return false
      }
      this.$COMAPI.changeCarrier(val).then((res) => {
        this.changeCarrierList = res || []
      })
    },
    // 新增
    addBtns() {
      this.$router.push('/OutgoingManage/OutgoingAdd')
    },
    // 修改
    WaybillEdit(row, key) {
      if (key == 1) {
        this.$router.push({
          path: '/OutgoingManage/OutgoingEdit',
          query: {
            outgoingId: row.outgoingId,
            waybillNumber: row.waybillNumber,
          },
        })
      } else if (key == 2) {
        this.$router.push({
          path: '/OutgoingManage/PendingOutboundEntry/SettlementEntry',
          query: {
            outgoingId: row.outgoingId,
          },
        })
      }
    },
    //
    transportPlan() {
      // this.$router.push({
      //   path: "/WaybillManage/TransportationPlann",
      //   query: {
      //     id: 1,
      //   },
      // });
    },

    // 过账
    guoZhang(row) {
      this.$router.push({
        path: '/OutgoingManage/OutgoingPosting',
        query: {
          outgoingId: row.outgoingId,
          waybillNumber: row.waybillNumber,
        },
      })
    },
    // 反过账
    fanGuoZhang(row) {
      let ids = []
      if (row) {
        ids.push(row.outgoingId)
      } else {
        if (this.selectTableData.length < 1) {
          this.$message.error('请选择需要反过账的外发单')
          return false
        }

        ids = this.selectTableData.map((item) => {
          return item.outgoingId
        })
      }
      this.$confirm(
        '确定要把选择的外发单进行 反过账 操作吗? 请谨慎操作',
        '提示:'
      )
        .then(() => {
          this.$API.wtl_cancelPosting({ outgoingIds: ids }).then((res) => {
            this.$message.success(res.data.message || '')
            this.getData()
          })
        })
        .catch(() => {})
    },
    // 删除外发单
    delBtns(row) {
      let ids = []
      if (row) {
        ids.push(row.outgoingId)
      } else {
        if (this.selectTableData.length < 1) {
          this.$message.error('请选择需要删除的外发单')
          return false
        }

        ids = this.selectTableData.map((item) => {
          return item.outgoingId
        })
      }

      this.$confirm('确定要把选择的外发单进行 删除 操作吗? 请谨慎操作', '提示:')
        .then(() => {
          this.$API.wtl_delOutgoingBill({ outgoingIds: ids }).then((res) => {
            this.$message.success(res.data.message || '')
            this.getData()
          })
        })
        .catch(() => {})
    },
    // 终止运单
    stopYd() {},
    // 合单
    heDan() {},

    // 选择图片
    changeFileList(array) {
      this.fileNameLists = array
    },
    /***
     * ====== 弹窗组件方法 ======
     */
    //  弹窗关闭事件(左上角的x和关闭按钮都算)
    handleCloseDia() {
      this.isShowDialog = false
      this.tableDataA = []
      this.dialogForm = {
        // 弹窗表单数据
        onoType: '',
        numbers: [],
        confDictKey: '',
      }
    },
    //  弹窗确认保存事件
    diaConfirmBtn() {
      // this.isShowDialog = false;
      let param = JSON.parse(JSON.stringify(this.dialogForm))

      let confDictKey = this.dialogForm.confDictKey;
      if("de_kun" === confDictKey){
        let paramDeKun = {
          "outgoingNumbers" : this.dialogForm.numbers,
          "appId" : "6bda86c21ea109ab",
          "apiUrl" : "https://openapi.dekuncn.com/gateway/kps/pro/kms-api/externalOrder/getWayBillLogByCustomer",
          "numberType" : this.dialogForm.onoType
        }
        this.$API
            .getOutgoingToDekunTrack(paramDeKun)
            .then((res) => {
              this.$message.success(res.data.message || '操作成功')
              this.tableDataA = res.data.result.pullInfoVos || []
            })
            .catch(() => {
              this.$message.error(res.data.message || '操作失败')
            })
      }else{
        this.$API
            .pullThirdApiPlatformData(param)
            .then((res) => {
              this.$message.success(res.data.message || '操作成功')
              this.tableDataA = res.data.result.pullInfoVos || []
            })
            .catch(() => {
              this.$message.error(res.data.message || '操作失败')
            })
      }

    },
    //  关闭弹窗按钮事件(关闭按钮)
    diaCancelBtn() {
      this.isShowDialog = false
      this.tableDataA = []
      this.dialogForm = {
        // 弹窗表单数据
        onoType: '',
        numbers: [],
        confDictKey: '',
      }
    },

    /***
     * ====== 弹窗组件方法 ======
     */

    // 跳转运单详情
    goYdDetails(a) {
      // this.$message.success("你点我干嘛");
      this.$router.push({
        path: '/WaybillManage/WaybillDetails',
        query: {
          yd: '123',
        },
      })
    },

    // 时间组件 选择时间后触发
    queryBtn_time(s, e) {
      this.startTime_a = s || ''
      this.endTime_a = e || ''
      // this.queryBtn_ok();
    },
    // 时间组件 选择类型后触发
    timestatus(type, s, e) {
      this.timeType = type || '0'
      this.startTime_a = s || ''
      this.endTime_a = e || ''
      // this.queryBtn_ok();
    },

    // 提交新建客服跟踪
    confirmAdd(formName) {
      this.showDia1 = false
      this.getData()
    },
    // 关闭客户跟踪弹窗,重置弹窗数据
    closeDia1(e) {
      this.showDia1 = e || false
      this.documentNumbers = '' //如果不重置这个,第二次点开同样的数据组件不会监听到变化默认是空的
    },
    handleSelectionChange(e) {
      // 表格选择事件
      this.selectTableData = e
    },
    // 点击选中当前行
    rowclick(row, event, column) {
      this.$refs.mytable.toggleRowSelection(row)
    },
    rowclick2(row, event, column) {
      this.$refs.memberTable.toggleRowSelection(row)
    },

    getData() {
      let startOutgoingTime = ''
      let endOutgoingTime = ''
      let startCreateTime = ''
      let endCreateTime = ''
      let startTakeTime = ''
      let endTakeTime = ''

      let startTime = this.startTime_a ? this.startTime_a + ' 00:00:00' : ''
      let endTime = this.endTime_a ? this.endTime_a + ' 23:59:59' : ''

      if (this.timeType == '0') {
        startCreateTime = startTime
        endCreateTime = endTime
      }
      if (this.timeType == '1') {
        startOutgoingTime = startTime
        endOutgoingTime = endTime
      }
      if (this.timeType == '2') {
        startTakeTime = startTime
        endTakeTime = endTime
      }

      let param = this.queryData
      param.startOutgoingTime = startOutgoingTime
      param.endOutgoingTime = endOutgoingTime
      param.startCreateTime = startCreateTime
      param.endCreateTime = endCreateTime
      param.startTakeTime = startTakeTime
      param.endTakeTime = endTakeTime
      param.pageStart = this.pageStart
      param.pageTotal = this.pageTotal

      this.$API.wtl_getOutgoingBillList(param).then((res) => {
        if (res.data.status === 'success') {
          this.className = res.data.result.className || ''
          this.tableData = res.data.result.data || []
          this.pageCount = res.data.result.pageCount || 0

          this.$nextTick(() => {
            this.fetTableHeight()
          })
        } else {
          this.$message.error(`${res.data.message}---综合查询列表`)
        }
      })
    },

    queryBtn_ok() {
      //  查询按钮
      this.pageStart = 1
      this.getData()
    },

    clerBtns() {
      //  重置按钮
      this.queryData = {
        endCreateTime: '',
        endOutgoingTime: '',
        outboundCarrierId: '',
        outgoingNumber: '',
        startCreateTime: '',
        startDeptId: '',
        startOutgoingTime: '',
        waybillNumber: '',
        isPosting: 0,
        isExpense: '',
        settlementMethodConfDictId: '',
        businessDeptId: '',
        arrivalArea: '',
        importNumber: '',
      }
    },

    moreParam() {
      this.isHaseMore = !this.isHaseMore
      if (this.isHaseMore) {
        this.MoreConditions = '收起条件'
      } else {
        this.MoreConditions = '更多条件'
      }

      this.$nextTick(() => {
        this.fetTableHeight()
      })
    },

    handleSizeChange(val) {
      //  分页
      this.pageTotal = val
      this.getData()
    },
    handleCurrentChange(val) {
      //  分页
      this.pageStart = val
      this.getData()
    },

    AddPackage() {
      //  添加包裹
      this.$router.push({
        path: '/BusinessManagement/addPacks',
      })
    },

    ModifyPackage() {
      //  修改包裹
      if (this.selectTableData.length === 1) {
        this.$router.push({
          path: '/BusinessManagement/addPacks',
          query: {
            packageId: this.selectTableData[0].packageId,
          },
        })
      } else {
        this.$message.error('请选一个需要修改的包裹')
      }
    },

    PackageDetails() {
      //  包裹详情
      if (this.selectTableData.length > 0) {
        this.$router.push({
          path: '/BusinessManagement/packsDetails',
          query: {
            packageId: this.selectTableData[0].packageId,
            courierNumber: this.selectTableData[0].courierNumber,
          },
        })
      } else {
        this.$router.push({
          path: '/BusinessManagement/packsDetails',
        })
      }
    },
    dabaoDetails() {
      //  包裹详情
      if (this.selectTableData.length === 1) {
        if (
          this.selectTableData[0].packageStatus ==
            'chu_ku_zai_tu:package_status' ||
          this.selectTableData[0].packageStatus ==
            'ke_hu_qian_shou:package_status' ||
          this.selectTableData[0].packageStatus ==
            'chu_ku_zhong:package_status' ||
          this.selectTableData[0].packageStatus ==
            'da_bao_wan_cheng:package_status'
        ) {
          this.$router.push({
            path: '/BusinessManagement/dabaoDetails',
            query: {
              packageId: this.selectTableData[0].packageId,
            },
          })
        } else {
          this.$message.error('包裹未打包完成')
        }
      } else {
        this.$message.error('请选择一个包裹')
      }
    },

    // 点击导出 (页面标识,表头,列表标识,数据源,表名)
    exportBtn() {
      this.$COMAPI.exportBtn({
        pageGroupName: this.pageGroupName, //页面标识
        myTableHeard: this.myTableHeard, //表头数组
        className: this.className, //列表标识
        tableData: this.tableData, //数据源
        sheetName: '表名(暂无效)', //表名
      })
    },

    // 表格合计
    getSummaries(param) {
      let that = this
      const { columns, data } = param

      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计'
          return
        }
        const values = data.map((item) => Number(item[column.property]))
        for (var i = 0; i < that.totalArr.length; i++) {
          if (column.property === that.totalArr[i]) {
            if (!values.every((value) => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr)
                if (!isNaN(value)) {
                  return this.$TOOLS.mathToFixed(this.$TOOLS.add(prev, curr), 2)
                } else {
                  return prev
                }
              }, 0)
              sums[index] += ''
            } else {
              sums[index] = '---'
            }
          }
        }
      })
      this.$nextTick(() => {
        this.$refs.mytable.doLayout()
      })
      return sums
    },

    /***
     * ==============设置表格动态高度==============
     */
    fetTableHeight() {
      // 重置table高度
      this.tabelHeigth = 0
      // 设置table高度
      let windonHeight =
        document.body.clientHeight || document.documentElement.clientHeight //页面高度
      let queryHeigth = 40 + 10 //10==margin-top: 10  查询框高度
      let btnListHeight = this.$refs.btnList.offsetHeight // 按钮列表高度
      if (this.isHaseMore) {
        queryHeigth = this.$refs.queryForm.offsetHeight + 10 //查询框
      }
      let pagsHeigth = 40 + 20 //分页组件高度 20是上下margin
      var otherHeight = queryHeigth + btnListHeight + pagsHeigth + 60 //60是顶部导航 10是
      let tabHeight = Math.floor(windonHeight - otherHeight) || '' //

      this.$nextTick(() => {
        this.tableHeigth = tabHeight
        this.$refs.mytable.doLayout()
      })
    },

    /****
     *  ===================下面页面公共方法 start ===================
     *
     */

    //顶部跟多按钮的操作
    topCommandBtns(a) {
      if (a === 'bgsz') {
        // 设置模板按钮
        // this.myModel();
        this.$TOOLS.myModel(this)
      }
      if (a === 'dyyd') {
        // 打印运单
      }
      if (a === 'dy_a') {
        // 打印标签
        this.isShowDialog_print = true
      }
      if (a === 'print_btn') {
        this.printEvent()
      }
      if (a === 'jtdc') {
        // 新版导出
        this.isShowDialog_dc = true
      }
    },
    //点击更多操作下的按钮
    handleCommandBtns(type, val) {
      if (type === 'a') {
        // 合世版本
        // this.guoZhang(val);

        // 荣祥版本
        this.WaybillEdit(val, 2)
      }
      if (type === 'b') {
        this.fanGuoZhang(val)
      }
      if (type === 'c') {
        this.delBtns(val)
      }
    },

    // =================== 排序表头彈窗的组件方法 start ===================
    //   取消按钮(表格设置)
    cancelSortHeard() {
      this.show_sortTableHeard = false
      this.$nextTick(() => {
        this.$refs.mytable.doLayout()
      })
    },
    // 排序==>确认按钮(表格设置)
    confirmOk(e) {
      this.tabelHeadeTitle = e
      this.myTableHeard = this.tabelHeadeTitle
      let sortObject = this.myTableHeard
      let param = {
        groupName: this.pageGroupName, //当前页面表格的标记(自定义字符串)
        sortName: this.sortName, //综合查询接口路径
        sortObject: JSON.stringify(sortObject),
      }
      this.$API.pushFindFieldSort(param).then((res) => {
        this.$message.success(res.data.message || '操作成功')
        //获取默认表头
        this.$TOOLS.getGroupFindFieldSort(this, this.pageGroupName)
      })
      this.show_sortTableHeard = false //关闭弹窗
      this.$nextTick(() => {
        this.$refs.mytable.doLayout()
      })
      this.show_sortTableHeard = false
    },
    // 点击某一项(表格设置)
    checktab(idx, e) {
      let that = this
      that.tabelHeadeTitle[idx].isShow = e
      let selectLength = 0
      for (var i = 0; i < that.tabelHeadeTitle.length; i++) {
        if (that.tabelHeadeTitle[i].isShow) {
          selectLength++
        }
      }
      that.selectLength = selectLength
      if (selectLength == that.tabelHeadeTitle.length) {
        that.allCheck = true
      } else {
        that.allCheck = false
      }
    },
    //全选(表格设置)
    checkAll(e) {
      let that = this
      this.allCheck = e
      for (var j = 0; j < this.tabelHeadeTitle.length; j++) {
        this.tabelHeadeTitle[j].isShow = e
      }
      let selectLength = 0
      for (var i = 0; i < that.tabelHeadeTitle.length; i++) {
        if (that.tabelHeadeTitle[i].isShow) {
          selectLength++
        }
      }
      that.selectLength = selectLength
    },
    //关闭弹窗(表格设置)
    closeDias(e) {
      this.show_sortTableHeard = e
    },

    /****
     *  ===================排序表头彈窗的组件方法 end ===================
     *
     */
  },
}
</script>
<style scoped lang="less">
.tableBox {
  height: calc(100% - 260px);
}

.colorStyle {
  color: #f00;
}

.mdTitName {
  height: 24px;
  border: 1px solid #d7d7d7;
  text-align: center;
  min-width: 100px;
}

.queryCriteria {
  .queryItem_one {
    .queryTextarea {
      border: 1px solid #d7d7d7;
    }
  }

  .timeBox {
    border: 1px solid #d7d7d7;
  }
}

.headerboxs {
  width: 100%;
  padding: 5px 0;
  display: flex;
  align-items: center;
}

.iconInput {
  display: flex;
  align-items: center;
}
.mainCOlorBtns {
  background-color: #f0a261;
  color: #fff;
  border: none;
}
.mainCOlorBtns :hover {
  color: #fff;
}
</style>
